var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticStyle:{"height":"55px"},attrs:{"color":"#1e87f0","dense":"","elevate-on-scroll":"","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(this.$route.name))]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }